export const formatTime = (seconds: number) => {
  const s = Math.max(0, Number(seconds) || 0);
  return `${Math.floor(s / 60)}:${String(Math.floor(s % 60)).padStart(2, "0")}`;
};

export const percent = (done: number, total: number) => (total ? Math.min(100, Math.round((done / total) * 100)) : 0);

/** `crypto.randomUUID` only exists in secure contexts; phones testing over plain-http LAN need a fallback. */
export const makeToken = () => globalThis.crypto?.randomUUID?.() ?? `t-${Date.now()}-${Math.random().toString(36).slice(2)}`;
